/**
 * Handle analytics
 *
 * @param container {HTMLElement} data atribut element
 */

const Analytics = (container) => {
  const { dataLayer } = window;

  document.addEventListener("scrollend", () => {
    if (container.classList.contains("sticky")) {
      if (container.classList.contains("is-active")) {
        if (!container.classList.contains("is-showing")) {
          dataLayer.push(JSON.parse(container.dataset.analyticsView));
          container.classList.add("is-showing");
        }
      } else {
        container.classList.remove("is-showing");
      }
    }
  });

  if (!container.classList.contains("sticky")) {
    dataLayer.push(JSON.parse(container.dataset.analyticsView));
  }
};

export default Analytics;
